export const reveal = {
	mounted(el) {
		el.setAttribute('data-reveal', '')

		if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						el.classList.add('is-visible')
						observer.unobserve(el)
					}
				})
			},
			// A ratio threshold never fires for elements much taller than the viewport
			// (e.g. the gallery on phones), so reveal on first overlap instead.
			{ threshold: 0, rootMargin: '0px 0px -10% 0px' }
		)
		observer.observe(el)
	},
}
